import { COLORS, MsdkStyledComponent, styled, TableRow } from '@msdk/ui'
import type React from 'react'

import { StyledTableCell, StyledTableCellProps } from '../utils'

export const PIVOT_LABEL_COLUMN_WIDTH = '220px'

export type PivotInteractiveCellProps = {
  $highlighted?: boolean
  $clickable?: boolean
}

type PivotBodyRowProps = React.ComponentProps<typeof TableRow>

const pivotInteractiveCellConfig = {
  shouldForwardProp: (prop: string) => prop !== '$highlighted' && prop !== '$clickable',
}

export const PivotBodyRow: MsdkStyledComponent<PivotBodyRowProps> = styled(TableRow)`
  &:hover {
    background-color: transparent;
    cursor: default;
  }
`

export const PivotHeaderCell: MsdkStyledComponent<StyledTableCellProps & PivotInteractiveCellProps> = styled(
  StyledTableCell,
  pivotInteractiveCellConfig,
)<PivotInteractiveCellProps>`
  font-weight: 600;
  padding: 8px;
  min-height: 56px;
  text-align: left;
  background-color: ${({ $highlighted }) => ($highlighted ? COLORS.action.selected : 'inherit')};
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};

  &:hover {
    padding: 8px;
  }
`

export const PivotRowLabelCell: MsdkStyledComponent<StyledTableCellProps> = styled(StyledTableCell)`
  font-weight: 600;
`

export const PivotDataCell: MsdkStyledComponent<StyledTableCellProps & PivotInteractiveCellProps> = styled(
  StyledTableCell,
  pivotInteractiveCellConfig,
)<PivotInteractiveCellProps>`
  background-color: ${({ $highlighted }) => ($highlighted ? COLORS.action.selected : 'inherit')};
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
`
